
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 85.337h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#496E2D","d":"M0 322.783h512v103.88H0z"}}),_c('path',{attrs:{"d":"M0 85.337h512v104.515H0z"}}),_c('path',{attrs:{"fill":"#A2001D","d":"M0 210.877h512v89.656H0z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M256 256.006L0 426.668V85.331z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M73.178 209.188l20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"}})])
          )
        }
      }
    